export default "__VITE_ASSET__3352965a__"